import type { Group } from "@/group";

export function getSelectedWidgetCountsByType(selectedWidgets: Group[]) {
    const map = new Map();

    for (const group of selectedWidgets) {
        let currentCodeName: string;

        if (group.isItemWrapper()) {
            const child = group.onlyChild();
            currentCodeName = child ? child.constructorName : "group";
        } else {
            currentCodeName = "group";
        }

        map.set(currentCodeName, (map.get(currentCodeName) ?? 0) + 1);
    }

    return map;
}
